import { LOCAL, IS_AUTH_POPUP, PRODUCTION } from '@/constants';

export const LOAD_MARKETING_SCRIPTS = !LOCAL && !IS_AUTH_POPUP;

export const LOAD_SMARTLOOK_SCRIPTS = PRODUCTION && !IS_AUTH_POPUP;

export const LOAD_EVENT_TRACKING_SCRIPTS = !LOCAL;
